var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-details-payment-plan"},[_c('MySteps',{attrs:{"steps":_vm.stepList,"current":_vm.currentStep,"activeColor":"#ff4d4f","inactiveColor":"#909399","finishColor":"#409eff","direction":"vertical"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }